import { PaginationProps } from '@components/V4/Pagination';
import Table from '@components/V4/Table/Table';
import Tooltip from '@components/V4/Tooltip';
import { ExclamationCircleIcon } from '@heroicons/react/outline';
import { GetEnrollmentsByIdsDTO } from '@shared/clientTypes/DTOs/EnrollmentsDTO';
import { ENROLLMENT_STATUS_TYPES } from '@shared/constants';
import { mergeClassNames } from 'apps/agora/src/utils/helpers';
import { BasicProps } from 'apps/agora/src/utils/types';
import moment from 'moment';
import { useState } from 'react';

interface EnrollmentsListProps extends BasicProps {
  enrollments?: GetEnrollmentsByIdsDTO['enrollments'];
  pagination: PaginationProps;
  areEnrollmentsLoading: boolean;
  onMentorModalOpen: (id: string) => void;
  onStudentModalOpen: (id: string) => void;
  onEnrollmentModalOpen: (id: string) => void;
}

const EnrollmentsList = (props: EnrollmentsListProps) => {
  const {
    enrollments,
    pagination,
    areEnrollmentsLoading,
    onMentorModalOpen,
    onStudentModalOpen,
    onEnrollmentModalOpen,
  } = props;

  return (
    <Table size="small" pagination={pagination}>
      <Table.Header>
        <Table.Row isHeader>
          <Table.HeaderCell>Course</Table.HeaderCell>
          <Table.HeaderCell>Student</Table.HeaderCell>
          <Table.HeaderCell>Mentor</Table.HeaderCell>
          <Table.HeaderCell>Start Date</Table.HeaderCell>
          <Table.HeaderCell>End Date</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body hasResults={!areEnrollmentsLoading && !!enrollments?.length}>
        {enrollments?.map((enrollment) => (
          <Table.Row key={enrollment._id}>
            <Table.Cell onClick={() => onEnrollmentModalOpen(enrollment._id)}>
              {enrollment.course?.title}
            </Table.Cell>
            <Table.Cell
              onClick={
                enrollment.student?._id
                  ? () => onStudentModalOpen(enrollment.student?._id)
                  : undefined
              }
            >
              <Tooltip text={enrollment.student?.isDeactivated ? 'Deactivated' : undefined}>
                <span
                  className={mergeClassNames('flex gap-1', {
                    'line-through': enrollment.student?.isDeactivated,
                  })}
                >
                  {enrollment.student?.name ?? 'n/a'}{' '}
                  {enrollment.student?.isDeactivated && (
                    <ExclamationCircleIcon className="w-4 h-4" aria-label="Deactivated user" />
                  )}
                </span>
              </Tooltip>
            </Table.Cell>
            <Table.Cell
              onClick={
                enrollment.mentor?._id ? () => onMentorModalOpen(enrollment.mentor?._id) : undefined
              }
            >
              {enrollment.mentor?.name ?? 'n/a'}
            </Table.Cell>

            <Table.Cell>
              {enrollment.startDate ? moment(enrollment.startDate).format('DD.MM.YYYY') : 'n/a'}
            </Table.Cell>
            <Table.Cell>
              {enrollment.endDate ? moment(enrollment.endDate).format('DD.MM.YYYY') : 'n/a'}
            </Table.Cell>

            <Table.Cell>{ENROLLMENT_STATUS_TYPES[enrollment.status] ?? 'n/a'}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default EnrollmentsList;
